import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import Web3 from 'web3';
import { MetamaskWallet, getAccount } from '../Hooks/useWallet';

import { setWalletAddress } from '../lib/localStorage';
import { useDispatch, useSelector } from "react-redux";
import { getOwnerAddress } from '../Hooks/useWeb3';
import toast from 'react-hot-toast';

const Connectwallet = ({ show, handleClose }) => {
  const [accounts, setAccounts] = useState([]);
  const dispatch = useDispatch();
  const [owner, setOwner] = useState([]);

  const connectWallet = async () => {
    if (window.ethereum) {
      try {
        // await window.ethereum.request({ method: 'eth_requestAccounts' });
        const web3 = new Web3(window.ethereum);
        // const accs = await web3.eth.getAccounts();
        // if (accs[0].toLowerCase() != owner.toLowerCase()) {
        //   toast.error("Please Connect Admin Account")
        // }
        // else {
        //   toast.success("Wallet Connected Successfully")
        //   setAccounts(accs[0]);
        //   setWalletAddress(accs[0])
        //   dispatch({
        //     type: "SET_ADMINWALLET",
        //     payload: accs[0],
        //   });
        // }

        MetamaskWallet()
          .then(async (data) => {
            const accs = await web3.eth.getAccounts();
            console.log("🚀 ~ .then ~ accs:", accs)
            // if (accs[0].toLowerCase() != owner.toLowerCase()) {
            //   toast.error("Please Connect Admin Account")
            // }
            // else {
              toast.success("Wallet Connected Successfully")
              setAccounts(accs[0]);
              setWalletAddress(accs[0])
              dispatch({
                type: "SET_ADMINWALLET",
                payload: accs[0],
              });
            // }

          })
          .catch((e) => {
            console.log(e);
          });

      } catch (error) {
        console.error('Error connecting to Wallet:', error);
      }
    } else {
      console.error('Wallet not detected');
    }
  };


  // const connectWallet = async () => {
  //   MetamaskWallet()
  //     .then(async (data) => {
  //     console.log("🚀 ~ .then ~ data:", data)

  //       handleClose();
  //     })
  //     .catch((e) => {
  //       console.log(e);
  //     });
  // };




  const getOwner = async () => {
    try {
      let ownerAddress = await getOwnerAddress()
      console.log("🚀 ~ getOwner ~ ownerAddress:", ownerAddress)
      setOwner(ownerAddress)
    } catch (err) {
      console.log(err, "err_logout");
    }
  };


  useEffect(() => {
    getOwner()
  }, []);

  return (
    <>
      <Modal size='sm' className='cmn_modal' centered
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >

        <Modal.Body>
          <div className='cmn_modal_header d-flex justify-content-between align-items-center'>
            <p className='cmn_modal_title'>Connect Wallet</p>
            <button className='cmn_modal_closer rounded-5' onClick={handleClose}><i class="fa-solid fa-xmark" /></button>
          </div>

          <div className='d-flex justify-content-center flex-column align-items-center mt-4 cmnModal__walletHolder' onClick={() => { connectWallet(); handleClose(); }}>
            <img src={require('../assets/images/metamask.svg').default} className='img-fluid cnctWallet__metamask' />
            <p className='cmn_modal_title mt-2'>Metamask</p>
          </div>

        </Modal.Body>

      </Modal>
    </>
  )
}

export default Connectwallet